import { css } from "@emotion/react"

type ImageProps = JSX.IntrinsicElements["img"] & {
  alt: string
  clearExtraSpace?: boolean
}
const Image = ({ clearExtraSpace = false, ...props }: ImageProps) => {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...props} loading="lazy" css={clearExtraSpace ? styles.clearExtraSpace : undefined} />
}

export default Image

/**
 * imgにvertical-align:middleを設定し、画像の下部に空白が発生しないようにする。
 * vertical-alignを指定しない場合、自動的にbaselineとして扱われる。
 * imgのheightを指定し、親要素のheightを指定しないケースでvertical-alignがbaselineとなっている場合
 * 画像の下部に数pxほど空白が発生することがある。
 */
const styles = {
  clearExtraSpace: css`
    vertical-align: middle;
  `,
}
